import { type Dispatch, type SetStateAction, useEffect } from "react";

import type { ImpersonationSession } from "../types";
import { clampBalloonPosition, clampWindowPosition } from "../utils/sessionHelpers";

/**
 * Keeps impersonation windows and balloons visible when the viewport is resized.
 */
export function useViewportClamp(
  sessionsCount: number,
  setSessions: Dispatch<SetStateAction<ImpersonationSession[]>>
) {
  useEffect(() => {
    if (sessionsCount === 0) {
      return;
    }

    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      setSessions((previous) =>
        previous.map((session) => ({
          ...session,
          position: clampWindowPosition(session, viewportWidth, viewportHeight),
          balloonPosition: clampBalloonPosition(
            session.balloonPosition,
            viewportWidth,
            viewportHeight
          ),
        }))
      );
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [sessionsCount, setSessions]);
}
